import React from 'react';
import Children from '../../interfaces/children.interface';
import ClassName from '../../interfaces/class-name.interface';
import Gap from '../../interfaces/gap.interface';
import Layer from '../../interfaces/layer.interface';
import TestId from '../../interfaces/test-id.interface';

export interface Props extends Children, ClassName, Gap, Layer, TestId {
  /** An optional background color (defaults to `white`) */
  bg?: string;

  /** Display type (defaults to `flex`) */
  display?: 'block' | 'flex' | 'grid';

  /** Flex direction - only applicable if display = flex */
  direction?: 'col' | 'row';

  /** Apply a default padding to the container (defaults to `false`) */
  padded?: boolean;
}

/** A container to enclose various contents */
const Container = ({
  bg = 'white',
  children,
  className = '',
  display = 'flex',
  direction = 'col',
  gap = 'none',
  layer = 0,
  padded = false,
  testId,
}: Props): React.ReactElement => (
  <div
    className={`
      ${display}
      ${display === 'flex' && direction ? `flex-${direction}` : ''}
      ${display === 'grid' ? 'grid-flow-col gap-8' : ''}
      ${padded ? 'p-8' : ''}
      bg-${bg}
      relative
      layer--${layer}
      gap--${gap}
      ${className}
    `}
    data-testid={testId}
  >
    {children}
  </div>
);

export default Container;
